import React, { useContext } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { DirectionContext } from "../App";

const CAPTURE_URL = "https://m.duo.co.kr/personalinfo/";

const AdditionalEvidenceLandingPage = () => {
  const { navigateTo } = useContext(DirectionContext);

  const handleSubmit = () => {
    navigateTo("/additionalevidence/guide");
  };

  const handleCapture = () => {
    window.open(CAPTURE_URL, "_blank", "noopener,noreferrer");
  };

  const pageVariants = {
    initial: { opacity: 0 },
    in: { opacity: 1, transition: { duration: 0.5 } },
    out: { opacity: 0, transition: { duration: 0.3 } },
  };

  const contentVariants = {
    initial: { opacity: 0, y: 20 },
    in: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.2, staggerChildren: 0.1 },
    },
  };

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <BackgroundImage />
        <Content variants={contentVariants} initial="initial" animate="in">
          <ButtonsContainer>
            <ApplyButton
              onClick={handleSubmit}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              증거 자료 제출
              <ArrowIcon
                $src="/png/arrowWhite.png"
                $color="#ffffff"
                role="img"
                aria-label="화살표"
              />
            </ApplyButton>

            <CheckButton
              onClick={handleCapture}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              듀오 개인정보 유출 확인
              <ArrowIcon
                $src="/png/arrowBlue.png"
                $color="#E31C20"
                role="img"
                aria-label="화살표"
              />
            </CheckButton>
          </ButtonsContainer>
        </Content>
      </Container>
    </PageBackground>
  );
};

const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  position: relative;

  @media (min-width: 769px) {
    padding: 20px;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 100vh;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  @media (min-width: 769px) {
    background-color: transparent;
    border-radius: 20px;
    height: 700px;
    min-height: 700px;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    padding: 0;
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("/png/bgadd.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;

  @media (max-width: 768px) {
    border-radius: 0;
  }

  @media (min-width: 769px) {
    background-image: url("/png/bgaddPC.png");
    border-radius: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  z-index: 2;
  width: 100%;
  height: 90%;
  position: relative;

  @media (max-width: 768px) {
    padding: 0 20px;
    min-height: 100vh;
  }

  @media (min-width: 769px) {
    min-height: 700px;
    padding: 60px 20px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 400px;
  position: absolute;
  top: 550px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 20px;

  @media (min-width: 769px) {
    bottom: 100px;
  }
`;

const ApplyButton = styled(motion.button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 56px;
  height: 56px;
  padding: 0 20px;
  border-radius: 20px;
  background: #e31c20;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;

  @media (min-width: 769px) {
    min-height: 56px;
    height: 56px;
  }
`;

const CheckButton = styled(motion.button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 56px;
  height: 56px;
  padding: 0 20px;
  border-radius: 20px;
  background: white;
  color: #e31c20;
  font-size: 16px;
  font-weight: 600;
  border: none;
  box-shadow: inset 0 0 0 1px #ffe8e8;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;

  @media (min-width: 769px) {
    min-height: 56px;
    height: 56px;
  }
`;

const ArrowIcon = styled.span`
  width: 16px;
  height: 16px;
  display: inline-block;
  flex-shrink: 0;
  background-color: ${(props) => props.$color || "currentColor"};
  -webkit-mask-image: url(${(props) => props.$src});
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
  mask-image: url(${(props) => props.$src});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
`;

export default AdditionalEvidenceLandingPage;
